import InfoCircleTip from './InfoCircleTip';

export default InfoCircleTip;
